import React from "react";
import PropTypes from "prop-types";
import {Menu} from "react-data-grid-addons";

let ContextMenu = Menu.ContextMenu;
let MenuItem = Menu.MenuItem;

export default class DeleteRowContextMenu extends React.Component {
  static propTypes = {
    onRowDelete: PropTypes.func.isRequired,
    rowIdx: PropTypes.any,
    idx: PropTypes.any
  };

  constructor(props) {
    super(props);

    this.onRowDelete = this.onRowDelete.bind(this);
  }

  onRowDelete(e, data) {
    if (typeof(this.props.onRowDelete) === 'function') {
      this.props.onRowDelete(e, data);
    }
  }

  render() {
    return (
      <ContextMenu identifier="context=menu">
        <MenuItem data={{rowIdx: this.props.rowIdx, idx: this.props.idx}}
                  onClick={this.onRowDelete}>Delete Row</MenuItem>
      </ContextMenu>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/admin/DeleteRowContextMenu.js
 **/